module.exports = __webpack_public_path__ + "img/eyes_female_asian_average.335a83ad.png";